import { units } from '@/features/units/schema';
import { FormRadioButtons } from '@/components/forms/FormRadioButtons';

export function FormUnits() {
  return (
    <FormRadioButtons 
      name="units" 
      label="Standard Units" 
      helperText="Choose your preferred unit system for recipes and grocery list" 
      options={units} />
  );
}
